export default "__VITE_ASSET__DCrWvdR___"